import { useTranslation } from "react-i18next"

import CustomRichText from "~/components/CustomRichText"

import { CookiesTable } from "./CookiesTable"

export type CookiesSectionProps = {
  name: string
  title: prismic.RichTextField
  description: prismic.RichTextField
  showValueInTable: boolean
}

export const CookiesSection: React.FC<CookiesSectionProps> = ({
  name,
  title,
  description,
  showValueInTable,
}) => {
  const { t } = useTranslation("privacy")

  return (
    <>
      <CustomRichText field={title} />
      <CustomRichText field={description} />

      <h4>{t("cookies.inUse")}</h4>
      <CookiesTable cookieName={name} showValue={showValueInTable} />
    </>
  )
}
